import { render, staticRenderFns } from "./ConfigSystemSystemMessage.vue?vue&type=template&id=86759be2&scoped=true&"
import script from "./ConfigSystemSystemMessage.vue?vue&type=script&lang=js&"
export * from "./ConfigSystemSystemMessage.vue?vue&type=script&lang=js&"
import style0 from "./ConfigSystemSystemMessage.vue?vue&type=style&index=0&id=86759be2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86759be2",
  null
  
)

export default component.exports